






































































































































import gql from 'graphql-tag'
import { Component, Mixins, Watch } from 'vue-property-decorator'

import AppConfirmModal from '@/components/AppConfirmModal.vue'
import AppEmptyCard from '@/components/AppEmptyCard.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import ItemTile from '@/components/ItemTile.vue'
import AppTabBar from '@/components/AppTabBar.vue'
import AppTile from '@/components/AppTile.vue'
import FilterModal from '@/components/FilterModal.vue'

import { User } from '@/mixins'

import { logEvent } from '@/common'
import { analytics } from '@/firebase'
import { CURRENT_USER } from '@/gql/auth'
import { FEED_TILE_FRAGMENT } from '@/gql/feed'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'
import { SHOW_LOGIN_MODAL } from '@/gql/misc'

@Component({
  components: {
    AppConfirmModal,
    AppEmptyCard,
    AppRouterLink,
    ItemTile,
    AppTabBar,
    AppTile,
    FilterModal
  },
  metaInfo () {
    const user = (this as any).userByUsername
    const content = `${(this as any).userName(user)} - ${user.description || ''}`
    return { meta: [{ name: 'description', content }] }
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    userByUsername: {
      query: gql`query ($username: String) {
        userByUsername(username: $username) {
          id
          username
          displayName
          description
          followerCount
          followedUserCount
          feedLikeCount
          isSubscribed @client
          instagramUrl
          youtubeUrl
          albaType
          media {
            id
            path
          }
          backgroundMedia {
            id
            path
          }
          shop {
            id
            domains
            status
          }
          savedFeeds @client {
            id
            thumbnailImagePath
          }
        }
      }`,
      variables () {
        return {
          username: this.$route.params.username
        }
      },
      async result ({ data }) {
        if (data.userByUsername && (!data.userByUsername.shop || data.userByUsername.shop.status === 'ACTIVE')) {
          document.title = `${this.userName(data.userByUsername)} - 페퍼로니`
          await logEvent('select_content', { item_id: data.userByUsername.id, content_type: 'user' })
          if (analytics) {
            await this.logAppsflyerEvent('af_content_view', {
              af_content_id: data.userByUsername.id,
              af_content_type: 'user'
            })
          }
        } else {
          await this.routerReplace('/not-found')
        }
      }
    },
    createdFeedConnection: {
      query () {
        return gql`query createdFeedConnectionAtUser($userId: Int, $after: String) {
          createdFeedConnection(userId: $userId, after: $after) {
            cursor
            hasNextPage
            feeds {
              ...FeedTileFragment
            }
          }
        }
        ${FEED_TILE_FRAGMENT}`
      },
      variables () {
        return this.variables
      },
      skip () {
        return this.currentTab !== 'USER_CREATED_FEED'
      }
    },
    shopItemReviewedFeedConnection: {
      query () {
        return gql`query shopItemReviewedFeedConnection($userId: Int, $after: String) {
          shopItemReviewedFeedConnection(userId: $userId, after: $after) {
            cursor
            hasNextPage
            feeds {
              ...FeedTileFragment
            }
          }
        }
        ${FEED_TILE_FRAGMENT}`
      },
      variables () {
        return this.variables
      },
      skip () {
        return this.currentTab !== 'SHOP_ITEM_REVIEWED_FEED'
      }
    },
    likedItemConnection: {
      query () {
        return gql`query ($userId: ID, $after: String, $strict: Boolean) {
          likedItemConnection(userId: $userId, after: $after, strict: $strict) {
            cursor
            hasNextPage
            items {
              ...ItemTileFragment
            }
          }
        }
        ${ITEM_TILE_FRAGMENT}`
      },
      variables () {
        return this.variables
      },
      skip () {
        return this.currentTab !== 'LIKED_ITEM'
      }
    },
    searchItem: {
      query () {
        return gql`query ($query: String!, $sellerId: ID, $options: AdvancedSearchOptionInput,
          $first: Int, $after: String) {
          searchItem(query: $query, sellerId: $sellerId, options: $options, first: $first, after: $after) {
            suggestedFilters
            usedFilter
            minPrice
            maxPrice
            isEmpty
            tags {
              id
              name
              type
              medias {
                id
                path
              }
            }
            searchedItemConnection {
              cursor
              hasNextPage
              items {
                ...ItemTileFragment
              }
            }
          }
        }
        ${ITEM_TILE_FRAGMENT}`
      },
      variables () {
        return this.variables
      },
      skip () {
        return this.currentTab !== 'SHOP_ITEM'
      }
    }
  }
})
export default class extends Mixins(User) {
  currentUser: { id: string; username: string } | null = null
  fetchMoreInProgress = false
  isFilterModalActive = false
  isFeedLikeCountModalActive = false

  get currentTab () {
    if (typeof this.$route.query.tab === 'string' && this.$route.query.tab) return this.$route.query.tab
    return this.userByUsername.shop ? 'SHOP_ITEM'
      : this.userByUsername.albaType === 'PEPPER' ? 'USER_CREATED_FEED' : 'LIKED_ITEM'
  }

  userByUsername: {
    id: string;
    displayName: string;
    username: string;
    description: string;
    followerCount: number;
    isSubscribed: boolean;
    savedFeeds: { }[];
    albaType: string;
    backgroundMedia?: {
      id: string;
      path: string;
    };
    shop?: {
      id: string;
      domains: string;
    };
  } = {
    id: '-20000',
    displayName: '',
    username: '',
    description: '',
    isSubscribed: false,
    followerCount: 0,
    savedFeeds: [],
    albaType: ''
  }

  createdFeedConnection: {
    cursor: string|null;
    hasNextPage: boolean;
    feeds: {}[];
  } = {
    cursor: null,
    hasNextPage: false,
    feeds: []
  }

  shopItemReviewedFeedConnection: {
    cursor: string|null;
    hasNextPage: boolean;
    feeds: {}[];
  } = {
    cursor: null,
    hasNextPage: false,
    feeds: []
  }

  likedItemConnection: {
    cursor: string|null;
    hasNextPage: boolean;
    items: {}[];
  } = {
    cursor: null,
    hasNextPage: false,
    items: []
  }

  searchItem: {
    suggestedFilters: string[];
    searchedItemConnection: {
      cursor: string|null;
      hasNextPage: boolean;
      items: {}[];
    };
    tags: object[];
  } = {
    suggestedFilters: [],
    searchedItemConnection: {
      cursor: null,
      hasNextPage: false,
      items: []
    },
    tags: []
  }

  queryFuncs: {
    [key: string]: {
      queryName: string;
      updateQuery: (prevResult: any, fetchMoreResult: any) => any;
    };
  } = {
    USER_CREATED_FEED: {
      queryName: 'createdFeedConnection',
      updateQuery: (previousResult, fetchMoreResult) => {
        return {
          ...fetchMoreResult,
          createdFeedConnection: {
            ...fetchMoreResult.createdFeedConnection,
            feeds: [
              ...previousResult.createdFeedConnection.feeds,
              ...fetchMoreResult.createdFeedConnection.feeds
            ]
          }
        }
      }
    },
    SHOP_ITEM_REVIEWED_FEED: {
      queryName: 'shopItemReviewedFeedConnection',
      updateQuery: (previousResult, fetchMoreResult) => {
        return {
          ...fetchMoreResult,
          shopItemReviewedFeedConnection: {
            ...fetchMoreResult.shopItemReviewedFeedConnection,
            feeds: [
              ...previousResult.shopItemReviewedFeedConnection.feeds,
              ...fetchMoreResult.shopItemReviewedFeedConnection.feeds
            ]
          }
        }
      }
    },
    LIKED_ITEM: {
      queryName: 'likedItemConnection',
      updateQuery: (previousResult, fetchMoreResult) => {
        return {
          ...fetchMoreResult,
          likedItemConnection: {
            ...fetchMoreResult.likedItemConnection,
            items: [
              ...previousResult.likedItemConnection.items,
              ...fetchMoreResult.likedItemConnection.items
            ]
          }
        }
      }
    },
    SHOP_ITEM: {
      queryName: 'searchItem',
      updateQuery: (previousResult, fetchMoreResult) => {
        return {
          searchItem: {
            ...fetchMoreResult.searchItem,
            searchedItemConnection: {
              ...fetchMoreResult.searchItem.searchedItemConnection,
              items: [
                ...previousResult.searchItem.searchedItemConnection.items,
                ...fetchMoreResult.searchItem.searchedItemConnection.items
              ]
            }
          }
        }
      }
    }
  }

  get connection () {
    switch (this.currentTab) {
      case 'USER_CREATED_FEED': return this.createdFeedConnection
      case 'SHOP_ITEM_REVIEWED_FEED': return this.shopItemReviewedFeedConnection
      case 'LIKED_ITEM': return this.likedItemConnection
      case 'SHOP_ITEM': return this.searchItem.searchedItemConnection
    }
    return { hasNextPage: false, cursor: '' }
  }

  get variables (): object {
    const query = this.$route.query

    switch (this.currentTab) {
      case 'USER_CREATED_FEED': return { userId: +this.userByUsername.id }
      case 'SHOP_ITEM_REVIEWED_FEED': return { userId: +this.userByUsername.id }
      case 'LIKED_ITEM': return { userId: this.userByUsername.id }
      case 'SHOP_ITEM': return {
        query: this.userByUsername.shop?.domains === 'BEAUTY' ? '뷰티' : '',
        sellerId: this.userByUsername.id,
        options: {
          categories: query.categories || [],
          colors: query.colors || [],
          excludeSoldOuts: this.booleanQueryValue('excludeSoldOuts', true),
          showOnlyDiscountedItems: this.booleanQueryValue('showOnlyDiscountedItems', false),
          showPepperOnlyItems: this.booleanQueryValue('showPepperOnlyItems'),
          showOnlyPaybackItems: this.booleanQueryValue('showOnlyPaybackItems'),
          sortSpec: query.sortSpec || 'CREATED_AT_DESC',
          minPrice: +query.minPrice || undefined,
          maxPrice: +query.maxPrice || undefined
        }
      }
    }
    return {}
  }

  @Watch('$route')
  async onRouteChanged (to: { query: { tab: string } }) {
    if (to.query.tab) {
      await this.$nextTick()
      this.scrollIntoView()
    }
  }

  scrollIntoView () {
    const ele = document.getElementById('view-user__tab-bar')
    if (ele) {
      ele.scrollIntoView()
    }
  }

  get availableTabs () {
    if (this.userByUsername.shop) {
      return [
        { id: 'USER_CREATED_FEED', name: '스토리' },
        { id: 'SHOP_ITEM', name: '아이템' },
        { id: 'SHOP_ITEM_REVIEWED_FEED', name: '태그' }
      ]
    } else {
      return [
        { id: 'USER_CREATED_FEED', name: '스토리' },
        { id: 'LIKED_ITEM', name: '아이템' }
      ]
    }
  }

  get currentFeeds () {
    switch (this.currentTab) {
      case 'USER_CREATED_FEED': return this.createdFeedConnection.feeds
      case 'SHOP_ITEM_REVIEWED_FEED': return this.shopItemReviewedFeedConnection.feeds
    }
    return []
  }

  get showFeedGrid () {
    return this.currentFeeds.length > 0
  }

  get currentItems () {
    switch (this.currentTab) {
      case 'LIKED_ITEM': return this.likedItemConnection.items
      case 'SHOP_ITEM': return this.searchItem.searchedItemConnection.items
    }
    return []
  }

  get showItemGrid () {
    return this.currentItems.length > 0
  }

  get currentCategories () {
    if (this.currentTab === 'SHOP_ITEM') {
      return [
        { id: '', name: '전체' },
        ...this.searchItem.suggestedFilters.map(filter => ({ id: filter, name: filter }))
      ]
    }
    return undefined
  }

  mounted () {
    window.onscroll = () => {
      if (!this.currentTab) return

      if (
        !this.connection.hasNextPage ||
        this.fetchMoreInProgress ||
        document.documentElement.scrollTop + window.innerHeight + 1000 < document.documentElement.offsetHeight
      ) return
      this.fetchMoreInProgress = true
      this.$apollo.queries[this.queryFuncs[this.currentTab].queryName].fetchMore({
        variables: {
          ...this.variables,
          after: this.connection.cursor
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          this.fetchMoreInProgress = false
          return this.queryFuncs[this.currentTab].updateQuery(previousResult, fetchMoreResult)
        }
      }).catch(e => e.name !== 'Invariant Violation' && console.error(e))
    }
  }

  async onClickSubscription (userId: string, name: string) {
    if (this.currentUser) {
      await this.toggleSubscription(this.currentUser.id, userId, name, this.userByUsername.isSubscribed)
    } else {
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
    }
  }

  async showLoginModal () {
    if (!this.currentUser) {
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
    }
  }

  get isFilterEnabled () {
    return !!(this.currentCategories /* && this.searchItem.tags.length */)
  }
}
